import { Expose, Type } from '@nts/std/serialization';
import { FieldMetaData } from './field-meta-data';
import { SimpleFieldMetaData } from './simple-field-meta-data';
import { ExternalFieldInputMode, FieldTypes } from '@nts/std/types';
import type { SimpleFieldMetaDataInterface } from '@nts/std/interfaces';
import type { ExternalLayoutMetaDataInterface } from '@nts/std/interfaces';

export class ExternalLayoutMetaData extends FieldMetaData implements ExternalLayoutMetaDataInterface {

  @Expose()
  @Type(() => SimpleFieldMetaData)
  availableExternalFields: SimpleFieldMetaDataInterface[];

  @Expose()
  searchProperties?: string[];

  @Expose()
  decodeProperties?: string[];

  @Expose()
  codeProperties?: SimpleFieldMetaDataInterface[];

  @Expose()
  fieldSeparator?: string;

  @Expose()
  inputMode: ExternalFieldInputMode;

  @Expose()
  dependantMetaDataFullName?: string;

  get isAutocomplete() {
    return this.inputMode == ExternalFieldInputMode.Autocomplete;
  }

  get isExternalList() {
    return this.inputMode == ExternalFieldInputMode.ExternalList;
  }

  getFieldType() {
    if (this.isExternalList) {
      return FieldTypes.ExternalList;
    }
    return FieldTypes.External;
  }
}
